import React, { useState, useEffect } from "react";
import "../../assets/css/invoice.css";
import { IoFilter } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdAddCircle } from "react-icons/io";
import InvoiceInsights from "./partials/InvoiceInsights";
import InvoiceList from "./partials/InvoiceList";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getInvoiceAnalytics } from "../../redux/reducers/invoiceSlice";

export default function Invoice() {
  const [activeStatus, setActiveStatus] = useState("All");
  const activeBusinessId = useSelector((state) => state.business.activeBusinessId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (activeBusinessId) {
      dispatch(getInvoiceAnalytics({ businessId: activeBusinessId }));
    }
  }, [dispatch, activeBusinessId]);

  const statuses = ["All", "Draft", "Sent", "Cancelled", "Paid"];

  return (
    <>
      <div className="mx-3 mt-4">
        <div className="dashboard-header d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
          <div className="pageTitle">
            <h1>Invoices</h1>
          </div>

          <div className="dashboard-actions d-flex align-items-center gap-3">
            {/* <Dropdown>
              <Dropdown.Toggle
                className="filter-dropdown-toggle shadow-sm"
                id="filter-dropdown"
              >
                <IoFilter size={18} /> {activeStatus === "All" ? "Filter" : activeStatus}
              </Dropdown.Toggle>

              <Dropdown.Menu className="filter-dropdown-menu mt-2">
                <div className="px-3 py-2 small fw-bold text-muted text-uppercase">Status Filter</div>
                {statuses.map((status) => (
                  <Dropdown.Item
                    key={status}
                    onClick={() => setActiveStatus(status)}
                    active={activeStatus === status}
                    className="filter-dropdown-item"
                  >
                    {status === "Draft" ? "Newly Added" : status}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown> */}

            <Link
              to="/create-invoice"
              className="btn btn-primary  d-flex align-items-center gap-2"
            >
              <IoMdAddCircle size={20} /> New Invoice
            </Link>
          </div>
        </div>
        <InvoiceInsights />
        <InvoiceList activeStatus={activeStatus} />
      </div>
    </>
  );
}
